import { render } from "./VF-inputNumber.vue?vue&type=template&id=00b810bd"
import script from "./VF-inputNumber.vue?vue&type=script&lang=js"
export * from "./VF-inputNumber.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__